export const overviewData = ({ qaReducer: { overview } }) => overview;
export const myQuestions = ({ qaReducer: { myQuestionsData } }) => myQuestionsData;
export const myAnswers = ({ qaReducer: { myAnswersData } }) => myAnswersData;
export const relatedQuestionsData = ({ qaReducer: { relatedQuestions } }) => relatedQuestions;
